var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "Alliance",
      "bg": "/images/sub/visual/sv4.jpg"
    }
  }), _c('section', {
    staticClass: "section section--first pb-0"
  }, [_c('v-container', [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('h2', {
    staticClass: "tit tit--lg dot-tit"
  }, [_vm._v(" Alliance ")])]), _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.onScrollFixed,
      expression: "onScrollFixed"
    }],
    staticClass: "scroll-fixed-tab w-100"
  }, [_c('scrollactive', {
    staticClass: "my-nav v-tabs v-tab--primary",
    attrs: {
      "offset": _vm.$vuetify.breakpoint.lgAndUp ? 177 : 102,
      "scrollOffset": _vm.$vuetify.breakpoint.lgAndUp ? 177 : 102,
      "highlightFirstItem": true,
      "active-class": "v-tab--active"
    }
  }, [_c('router-link', {
    staticClass: "scrollactive-item v-tab",
    attrs: {
      "to": "#abb"
    }
  }, [_vm._v("ABB")]), _c('router-link', {
    staticClass: "scrollactive-item v-tab",
    attrs: {
      "to": "#teledyne"
    }
  }, [_vm._v("TELEDYNE")]), _c('router-link', {
    staticClass: "scrollactive-item v-tab",
    attrs: {
      "to": "#pac"
    }
  }, [_vm._v("PAC")]), _c('router-link', {
    staticClass: "scrollactive-item v-tab",
    attrs: {
      "to": "#metal"
    }
  }, [_vm._v("METAL SAMPLES")]), _c('router-link', {
    staticClass: "scrollactive-item v-tab",
    attrs: {
      "to": "#extrel"
    }
  }, [_vm._v("EXTREL")])], 1)], 1)])], 1), _c('section', {
    staticClass: "section pt-0",
    attrs: {
      "id": "abb"
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": "ABB",
      "bgImage": "/images/sub/alliance/abb-bg.jpg",
      "image": "/images/sub/alliance/abb-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v(" 분석 측정 기술을 이용하여 모든 문제를 해결할 수 있는"), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 1,000여개의 솔루션을 손쉽게 구축할 수 있습니다. ")]), _c('p', {
    staticClass: "page-text"
  }, [_vm._v("솔루션 및 일괄 공급이 가능한 공급업체로써 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("케이아이이 시스템즈의 신뢰할 수 있는 파트너입니다.")]), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-80"
  }, [_c('v-btn', {
    staticClass: "justify-space-between",
    attrs: {
      "outlined": "",
      "tile": "",
      "width": "180",
      "color": "primary",
      "href": "https://global.abb/group/en",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Web site")]), _c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)])], 1)], 1), _c('section', {
    staticClass: "section pt-0",
    attrs: {
      "id": "teledyne"
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": "TELEDYNE",
      "bgImage": "/images/sub/alliance/teledyne-bg.jpg",
      "image": "/images/sub/alliance/teledyne-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("Teledyne은 산업 성장 시장을 위한 정보를 감지, 전송 및 분석할 수 있는 지원 기술을 제공합니다. 이러한 시장에는 항공 우주 및 방위, 공장 자동화, 대기 및 수질 환경 모니터링, 전자 설계 및 개발, 해양 연구, 에너지, 의료 영상 및 제약 연구 등이 포함됩니다.")]), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-80"
  }, [_c('v-btn', {
    staticClass: "justify-space-between",
    attrs: {
      "outlined": "",
      "tile": "",
      "width": "180",
      "color": "primary",
      "href": "https://www.teledyne-ai.com/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Web site")]), _c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)])], 1)], 1), _c('section', {
    staticClass: "section pt-0",
    attrs: {
      "id": "pac"
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": "PAC",
      "bgImage": "/images/sub/alliance/pac-bg.jpg",
      "image": "/images/sub/alliance/pac-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("PAC는 석유화학, 정유, 업스트림, 바이오 연료, 환경, 식품 및 음료, 윤활제, 자동차 및 제약과 같은 산업에서 실험실 및 온라인 프로세스 응용을 위한 고급 분석 기기의 선도적인 글로벌 제조업체입니다.")]), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-80"
  }, [_c('v-btn', {
    staticClass: "justify-space-between",
    attrs: {
      "outlined": "",
      "tile": "",
      "width": "180",
      "color": "primary",
      "href": "https://www.paclp.com/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Web site")]), _c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)])], 1)], 1), _c('section', {
    staticClass: "section section--last pt-0",
    attrs: {
      "id": "metal"
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": "Metal Samples",
      "bgImage": "/images/sub/alliance/metal-bg.jpg",
      "image": "/images/sub/alliance/metal-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("Metal Samples는 부식 모니터링 및 재료 평가를 위한 제품을 전문적으로 제조하며, 1980년 이래로 전 세계의 화학 처리, 수처리 및 석유 산업에 제품과 서비스를 공급해 왔습니다.")]), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-80"
  }, [_c('v-btn', {
    staticClass: "justify-space-between",
    attrs: {
      "outlined": "",
      "tile": "",
      "width": "180",
      "color": "primary",
      "href": "https://www.alspi.com/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Web site")]), _c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)])], 1)], 1), _c('section', {
    staticClass: "section section--last pt-0",
    attrs: {
      "id": "extrel"
    }
  }, [_c('v-container', [_c('top-image', {
    attrs: {
      "tit": "EXTREL",
      "bgImage": "/images/sub/alliance/extrel-bg.jpg",
      "image": "/images/sub/alliance/extrel-img.jpg"
    }
  }, [_c('p', {
    staticClass: "page-text mb-6 mb-lg-20"
  }, [_vm._v("Extrel 공정 질량 분석기는 Hydrocarbon 공정, Syngas 제조, 금속 제조, Gas Purity 등과 같은 분야에서 높은 신뢰성과 편의성을 제공합니다. 이 분석기는 전 세계 수천 개의 제조 시설에서 사용되고 있으며, 40년 이상의 산업 자동화 분야에서의 노하우를 쌓아온 전문가들이 설계하였습니다.")]), _c('div', {
    staticClass: "mt-30 mt-md-60 mt-lg-80"
  }, [_c('v-btn', {
    staticClass: "justify-space-between",
    attrs: {
      "outlined": "",
      "tile": "",
      "width": "180",
      "color": "primary",
      "href": "https://www.extrel.com/",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v("Web site")]), _c('v-icon', {
    attrs: {
      "size": "16"
    }
  }, [_vm._v("mdi-open-in-new")])], 1)], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }